import { useEffect, useState } from "react";

import CurrencyInput from "react-currency-input-field";
import { CurrencyInputOnChangeValues } from "react-currency-input-field/dist/components/CurrencyInputProps";

interface USDFieldProps {
  limit?: number;
  placeholder?: string;
  value?: number;
  disabled?: boolean;
  onChange?: (_: number | undefined) => void;
}

const USDField: React.FC<USDFieldProps> = ({
  limit,
  placeholder,
  value,
  disabled,
  onChange,
}) => {
  const prefix = "$";

  const [className, setClassName] = useState("");
  const [editingValue, setEditingValue] = useState<string | number>(
    value ? Number(value) : ""
  );
  const [errorMessage, setErrorMessage] = useState("");

  const handleOnValueChange = (
    newValue?: string,
    _?: string,
    values?: CurrencyInputOnChangeValues
  ): void => {
    if (!newValue) {
      setClassName("");
      setEditingValue("");

      if (onChange) {
        onChange(undefined);
      }

      return;
    }

    if (values?.float === undefined || values?.float === null) {
      setErrorMessage("Introduzca un monto válido");
      setClassName("is-invalid");
      return;
    }

    if (limit && values.float > limit) {
      let formatter = new Intl.NumberFormat("es-PY");
      setErrorMessage(`Máximo: ${prefix}${formatter.format(limit)}`);
      setClassName("is-invalid");
      setEditingValue(newValue);
      return;
    }

    setClassName("is-valid");
    setEditingValue(newValue);

    if (onChange) {
      onChange(values.float);
    }
  };

  useEffect(() => {
    if (value !== undefined) {
      setEditingValue(value);
    } else {
      setEditingValue("");
    }
  }, [value]);

  return (
    <>
      <CurrencyInput
        className={`form-control ${className}`}
        placeholder={placeholder}
        allowDecimals={true}
        decimalsLimit={2}
        groupSeparator="."
        decimalSeparator=","
        prefix={prefix}
        onValueChange={disabled ? undefined : handleOnValueChange}
        value={editingValue ? editingValue : ""}
        disabled={disabled}
      />
      <div className="invalid-feedback">{errorMessage}</div>
    </>
  );
};

export default USDField;
